import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import "./LoginPage.css";

const LoginPage = ({ onLoginSuccess }) => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000);
  };

  const handleLogin = async () => {
    try {
      const result = await api.checkLogin(userName, password);
      const table = result?.AssetCheckLoginApi?.Table || [];
      const loginData = table[0];

      if (loginData?.Loginmsg === "Success") {
        showMessage("Login Successful!", "success");

        sessionStorage.setItem("userName", loginData.UsrName);
        sessionStorage.setItem("userId", loginData.Usrid);
        localStorage.setItem("isLoggedIn", "true");

        console.log("userName:", loginData.UsrName);
        console.log("userId:", loginData.Usrid);

        await fetchCompanyDetails(loginData.UsrName);

        if (onLoginSuccess) onLoginSuccess();

        navigate("/summary-rev", { replace: true });
      } else {
        showMessage("Username or Password incorrect", "error");
      }
    } catch (error) {
      console.error("Login failed:", error);
      showMessage("Login Failed: " + error.message, "error");
    }
  };

  const fetchCompanyDetails = async (loginUserName) => {
    try {
      const response = await api.CompanyDetailsAPI(loginUserName);
      console.log("CompanyDetailsAPI Response:", response);

      const table =
        response?.CompanyDetailsAPIjs?.Table ||
        response?.Table ||
        response?.CompanyDetailsAPIjs ||
        [];

      const company = table[0];

      if (company) {
        sessionStorage.setItem("companyId", company.Comid);
        sessionStorage.setItem("companyName", company.Comname);
        sessionStorage.setItem("companyPropName", company.PropName);

        console.log("Company Details Saved:", company);
      } else {
        console.warn("No company details found in API response:", response);
      }
    } catch (err) {
      console.error("Error fetching company details:", err);
    }
  };

  return (
    <div className="lp-wrapper">
      <header className="lp-header">
        <div className="lp-header-mark" aria-hidden="true">
          <img src="/Assets/CompanyLogo.png" alt="" className="lp-header-logo" />
        </div>
        <div className="lp-header-title">Sivanandha Pipe Fittings Ltd</div>
      </header>

      <main className="lp-main">
        <section className="lp-card">
          <div className="lp-card-header">Log In</div>

          <div className="lp-card-body">
            <div className="lp-icon-col" aria-hidden="true">
              <img
                src="/Assets/login.png"
                alt=""
                className="lp-login-illustration"
              />
            </div>

            <div className="lp-form-col">
              <div className="lp-field">
                <label htmlFor="login-username">User Name</label>
                <input
                  id="login-username"
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>

              <div className="lp-field">
                <label htmlFor="login-password">Password</label>
                <input
                  id="login-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="lp-actions">
                <button type="button" className="lp-forgot-btn">
                </button>
                <button type="button" onClick={handleLogin} className="lp-login-btn">
                  Login
                </button>
              </div>

              <div className="lp-ip-ref">Ip. Ref : 163.53.206.54</div>
            </div>
          </div>
        </section>

        {message && (
          <div className={`lp-message ${message.type === "success" ? "success" : "error"}`}>
            {message.text}
          </div>
        )}
      </main>
    </div>
  );
};

export default LoginPage;
